import { Moment } from 'moment';

export const addTheBookingLengthToTheTimeAndSubtractOneSecond = (
  time: Moment,
  defaultBookingLength: number,
) => {
  return time.clone().add(defaultBookingLength, 'minutes').add(-1, 'seconds');
};
